import { Col, Row } from "reactstrap";
import TableComponent from "../../../components/TableComponent";
import { CLICK_ACTIONS } from "../../../utils/Constant";
import { ColumnHeaderType } from "../../../utils/Types";
import { ROLE_PERMISSION_HEADERS } from "../RoleMasterHelper";
import LabelField from "../../../components/LabelField";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TextInput from "../../../components/TextInput";
import SelectInput from "../../../components/SelectInput";
import { checkNullValue, getLobData } from "../../../utils/Util";
import { createRolePermissions, getActiveSessions, updateRolePermissions } from "../../../api/roleMasterApi";
import ActiveSessionModal from "../../../modals/ActiveSessionModal";
import { FormUtils } from "../../../utils/FormUtils";
import { mapLOBMaster } from "../../../utils/MastersMapping";

interface FormData {
    roleName: string;
    roleDescription: string;
    roleStatus: string;
    lineOfBusiness: string;
    rolePermissions: {
        dashboardTab: boolean,
        roleMasterTab: boolean,
        userAccessTab: boolean,
        downloadReportsTab: boolean,
        updateGrievanceIntimationDate: boolean,
        reopenCloseGrievance: boolean,
        createGrievance: boolean,
        updateDepartment: boolean,
        typeOfRequestWrite: boolean,
        resolutionRemarks: boolean,
        activityLog: boolean,
        reassignSpoc: boolean,
        assignSpoc: boolean,
        updateLineOfBusiness: boolean,
    };
}

interface RolePermissionsProps{
    roleData?: any;
    setShowPermissionsSection: (value: boolean) => void;
    action: string;
    setFlag: (value: boolean) => void;
}
const RolePermissions = ({
    roleData,
    setShowPermissionsSection,
    action,
    setFlag
}:RolePermissionsProps) => {

    const {
        storeLOBData,
    } = useSelector((state: any) => state.grievances);
    const {
        roleStatusStore,
        storeAllPermissions,
        storeGroupRoles,
        storeCreateRoleRes,
        storeUpdateRoleRes,
        storeActiveSessions
    } = useSelector((state: any) => state.roleMaster);
    const dispatch: any = useDispatch();

    const roleStatusData = roleStatusStore ?? [];
    const lobData = getLobData(FormUtils.convertDataList(
        storeLOBData?.data ?? []
    ));
    const [openSessionModal, setOpenSessionModal] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [submitData, setSubmitData] = useState<FormData>();
    const [isInitialChanged, setInitialChanged] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors },
    } = useForm<FormData>({
        defaultValues: {
            roleName: roleData?.name ?? '',
            roleDescription: roleData?.description ?? '',
            roleStatus: roleData?.roleStatus ?? '',
            lineOfBusiness: '',
            rolePermissions: {
                dashboardTab: false,
                roleMasterTab: false,
                userAccessTab: false,
                downloadReportsTab: false,
                updateGrievanceIntimationDate: false,
                reopenCloseGrievance: false,
                createGrievance: false,
                updateDepartment: false,
                typeOfRequestWrite: false,
                resolutionRemarks: false,
                activityLog: false,
                reassignSpoc: false,
                assignSpoc: false,
                updateLineOfBusiness: false,
            },
        },
        mode: 'all',
    });

    const onSubmit = (data: FormData) => {
        setSubmitData(data)
        const permissionList = getUpdatedPermissionsArray(data?.rolePermissions);
        setPermissions(permissionList)
        if(action === 'update-role'){
            if(data?.roleStatus === 'Inactive'){
                sessionCheck(roleData?.name);
            }
            else if(data?.roleStatus === 'Active'){
                dispatch(updateRolePermissions(permissionList, data?.roleStatus, roleData?.name, data?.lineOfBusiness));
            }
        }
        else if(action === 'create-role'){
            dispatch(createRolePermissions(permissionList, data));
        }
    }

    useEffect(() => {
        if(storeCreateRoleRes?.response === 'created' || storeUpdateRoleRes?.response === 'created'){
            setShowPermissionsSection(false);
            setFlag(true);
        }
    },[storeCreateRoleRes, storeUpdateRoleRes])

    const onChangeInput = (label: any, value: any,) => {
        setValue(label, value, { shouldValidate: true })
    }  

    
    const [rolePermissionsData, setRolePermissionsData] = useState<any>([]);
    useEffect(()=>{
        let data: any = []
        storeAllPermissions?.map((each: any) => {
            each?.name !== 'uma_protection' &&
            data.push({
                functionality: getPermissionName(each?.name),
                formControl: `rolePermissions.${getPermissionValue(each?.name)}`,
                onChangeInput: onChangeInput,
                getValues: getValues,
            })
        })
        setRolePermissionsData(data)
    },[storeAllPermissions])   

    const onTableAction = (each: any, headerItem: ColumnHeaderType) => {
        if(headerItem.action === CLICK_ACTIONS.SET_PERMISSIONS){
            // console.log(each)
        }
    };

    const roleStatus = watch('roleStatus');
    useEffect(()=>{
        setValue('roleStatus', roleData?.status === true ? 'Active' : roleData?.status === false ? 'Inactive' : '')
        if(storeGroupRoles){getPermissions();}
        let lob = mapLOBMaster(roleData?.lobId);
        setValue('lineOfBusiness', typeof lob == 'string'  && lob != 'N/A' ? lob : '')
    },[])


    const getPermissions = () => {
        if (storeGroupRoles && action == 'update-role') {
            storeGroupRoles?.data.map((each: any) => {
                const permissionKey = getPermissionValue(each?.name);
                setValue(`rolePermissions.${permissionKey}`, true);
            });
        }
    }
    const getPermissionValue = (name: string): keyof FormData['rolePermissions'] => {
        return name?.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase()) as keyof FormData['rolePermissions'];
    };

    const getPermissionName = (name: string): string => {
        return name
        ?.split('-') // Split the string by hyphens
        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        ?.join(' '); // Join the words with spaces
    };
    
    const getUpdatedPermissionsArray = (rolePermissions: any) => {
        const updatedArray = storeGroupRoles?.data ? storeGroupRoles.data.map((item: any) => item.name) : [];
        if(rolePermissions){
            Object.keys(rolePermissions).forEach((key) => {
                const originalKey = key.replace(/([A-Z])/g, '-$1').toLowerCase(); // Convert abCd to ab-cd
                const isPermissionTrue = rolePermissions[key];
        
                const index = updatedArray.indexOf(originalKey);
        
                if (isPermissionTrue && index === -1) {
                    updatedArray.push(originalKey);
                } else if (!isPermissionTrue && index !== -1) {
                    updatedArray.splice(index, 1);
                }
            });
        }
    
        return updatedArray;
    };

    const sessionCheck = (roleName: string) => {
        dispatch(getActiveSessions(roleName));
    }

    useEffect(() => {
        if(storeActiveSessions?.length > 0 && action === 'update-role' && submitData){
            toggleSessionModal();
        }
        else if(submitData){
            dispatch(updateRolePermissions(permissions, submitData?.roleStatus, roleData?.name, submitData?.lineOfBusiness));
        }
    },[storeActiveSessions])

    const [isUpdated, setIsUpdated] = useState(false);
    const [initialPermissions, setInitialPermissions] = useState<FormData['rolePermissions']>({
        dashboardTab: false,
        roleMasterTab: false,
        userAccessTab: false,
        downloadReportsTab: false,
        updateGrievanceIntimationDate: false,
        reopenCloseGrievance: false,
        createGrievance: false,
        updateDepartment: false,
        typeOfRequestWrite: false,
        resolutionRemarks: false,
        activityLog: false,
        reassignSpoc: false,
        assignSpoc: false,
        updateLineOfBusiness: false,
    });
    
    const formValues = watch();
    
    useEffect(() => {
        if(!formValues?.rolePermissions && storeGroupRoles?.data != undefined && storeGroupRoles?.data.length == 0){
            setInitialChanged(true)
        }
        if (formValues?.rolePermissions && !isInitialChanged) {
                setInitialPermissions(prevPermissions => ({
                    ...prevPermissions,
                    ...formValues.rolePermissions
                }));
                setInitialChanged(true)
        }
    }, [formValues, initialPermissions, isInitialChanged]);
    
    useEffect(() => {
        if (formValues?.rolePermissions) {
            const permissionsChanged = Object.keys(formValues.rolePermissions).some(
                (key) => formValues.rolePermissions[key as keyof typeof formValues.rolePermissions] !== initialPermissions[key as keyof typeof initialPermissions]
            );
            setIsUpdated(permissionsChanged);
        }
    }, [formValues, initialPermissions]);
    
    const toggleSessionModal = () => {
        setOpenSessionModal(!openSessionModal);
    }

    const getRoleStatus = () => {
        return roleData?.status === true ? 'Active' : roleData?.status === false ? 'Inactive' : ''
    }

    const checkDisability = () => {
        const currentRoleName = getValues('roleName');
        const currentRoleDescription = getValues('roleDescription');
        const currentRoleStatus = getValues('roleStatus');
        const currentLOB = getValues('lineOfBusiness');

        const isNameSame = currentRoleName === roleData?.name;
        const isDescriptionSame = currentRoleDescription === roleData?.description;
        const isStatusSame = currentRoleStatus === getRoleStatus();
        const isLOBSame = !currentLOB || currentLOB === mapLOBMaster(roleData?.lobId);
    
        if(isUpdated){
            return false;
        }    
        else if(isNameSame && isDescriptionSame && isStatusSame && isLOBSame) {
            return true;
        }
        else{
            return false;
        }
    };

    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])

    return (
        <>            
            <div style={{display:'flex', alignItems:'center', gap:'1rem'}}>
                <img 
                    src={require('../../../assets/img/Back.svg').default} 
                    alt="back-img"
                    style={{cursor: 'pointer'}}
                    onClick={() => {setShowPermissionsSection(false);setFlag(false);}}
                />
                {roleData ? 
                    <span className="page-header">Role Details</span>
                    :
                    <span className="page-header">Create Role</span>
                }
            </div>

            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <div style={{width: '99%', margin: '2% 5px', padding:'2%'}} className="border rounded">
                    {roleData ? 
                        <Row className="mb-2">
                            <Col md={3}>
                                <LabelField name='Role Name'></LabelField>
                                <p className='grievance-details'>{roleData?.name}</p>
                            </Col>
                            <Col md={3}> 
                                <LabelField name='Role Description'></LabelField>
                                <p className='grievance-details'>{checkNullValue(roleData?.description)}</p>
                            </Col> 
                            <Col md={3}>
                                <LabelField name='Role Status' required={true}></LabelField>
                                <SelectInput
                                    changeFun={onChangeInput}
                                    formValue={getValues('roleStatus')}
                                    valueName={'roleStatus'}
                                    register={register('roleStatus')}
                                    errors={errors}
                                    data={roleStatusData}
                                    className="role-inputs"
                                />
                            </Col>
                            <Col md={3}>
                                <LabelField name='Line of Business'></LabelField>
                                <SelectInput
                                    changeFun={onChangeInput}
                                    formValue={getValues('lineOfBusiness')}
                                    valueName={'lineOfBusiness'}
                                    register={register('lineOfBusiness')}
                                    errors={errors}
                                    data={lobData}
                                    className="role-inputs"
                                />
                            </Col>
                        </Row>
                        :
                        <Row className="mb-2">
                            <Col xs={8} md={3}>
                                <LabelField name='Role Name' required={true}></LabelField>
                                <TextInput
                                    changeFun={onChangeInput}
                                    valueName={'roleName'}
                                    register={register('roleName',{ pattern: /^[^#]*$/})}
                                    errors={errors}
                                    formValue={getValues('roleName')}
                                    className="role-inputs-text"
                                />
                            </Col>
                            <Col xs={8} md={3}>
                                <LabelField name='Role Description' required={true}></LabelField>
                                <TextInput
                                    changeFun={onChangeInput}
                                    valueName={'roleDescription'}
                                    register={register('roleDescription',{ pattern: /^[^#]*$/})}
                                    errors={errors}
                                    formValue={getValues('roleDescription')}
                                    className="role-inputs-text"
                                />
                            </Col>
                            <Col xs={8} md={3}>
                                <LabelField name='Role Status' required={true}></LabelField>
                                <SelectInput
                                    changeFun={onChangeInput}
                                    formValue={getValues('roleStatus')}
                                    valueName={'roleStatus'}
                                    register={register('roleStatus')}
                                    errors={errors}
                                    data={roleStatusData}
                                    className="role-inputs"
                                />
                            </Col>
                            <Col xs={8} md={3}>
                                <LabelField name='Line of Business' required={true}></LabelField>
                                <SelectInput
                                    changeFun={onChangeInput}
                                    formValue={getValues('lineOfBusiness')}
                                    valueName={'lineOfBusiness'}
                                    register={register('lineOfBusiness')}
                                    errors={errors}
                                    data={lobData}
                                    className="role-inputs"
                                />
                            </Col>
                        </Row>
                    }
                </div>

                <TableComponent 
                    onAction={onTableAction}
                    data={rolePermissionsData}
                    columnHeaders={ROLE_PERMISSION_HEADERS}
                    style={{ marginBottom: '66px' }}
                />

                <div className="update-permission">
                    <button 
                        className='button' 
                        type="submit"
                        disabled={
                            (action === 'update-role' && (checkDisability())) ||
                            (action === 'create-role' && 
                                !(getValues('roleStatus')?.length > 0 && 
                                  getValues('roleName')?.length > 0 && 
                                  getValues('roleDescription')?.length > 0 && 
                                  getValues('lineOfBusiness')?.length > 0))
                        }
                        
                    >
                        Save
                    </button>
                    
                    <button 
                        className='resetButton' 
                        onClick={() => {setShowPermissionsSection(false); setFlag(false);}}
                    >
                        Cancel
                    </button>
                </div>
            </form>

            

            {openSessionModal && 
                <ActiveSessionModal
                    openModal={openSessionModal}
                    toggle={toggleSessionModal}
                    permissionList={permissions}
                    formData={submitData}
                    roleData={roleData}
                />
            }
        </>
    );
}

export default RolePermissions;